export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"defaults": {"httpEndpoint": "https://api1.emissary.ai/graphql", "httpLinkOptions": {"credentials": "include"}, "defaultOptions": {"watchQuery": {"fetchPolicy": "cache-and-network"}}, "tokenName": "auth-token", "tokenStorage": "localStorage", "authType": "JWT", "websocketsOnly": false, "authHeader": "Authorization"}}
}